module.exports = __webpack_public_path__ + "img/mouth_female_average_mask.37808eaa.png";